var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 20,
    viewBox: "0 0 67 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30555 9.44444V0H0.5V9.44444C0.5 15.2741 5.17862 20 10.95 20C16.7214 20 21.4 15.2741 21.4 9.44444V0H15.5944V9.44444C15.5944 12.0354 13.9861 14.4444 10.95 14.4444C7.91391 14.4444 6.30555 12.0354 6.30555 9.44444ZM28.8556 9.44444V0H23.05V9.44444C23.05 15.2741 27.7286 20 33.5 20C39.2714 20 43.95 15.2741 43.95 9.44444V0H38.1444V9.44444C38.1444 12.0354 36.4174 14.4444 33.5 14.4444C30.5826 14.4444 28.8556 12.0354 28.8556 9.44444ZM56.05 0C61.8214 0 66.5 4.47715 66.5 10C66.5 15.5228 61.8214 20 56.05 20H45.6V0H56.05ZM56.3224 4.99988H51.4048V14.9999H56.3224C58.6143 14.9999 60.6937 12.7613 60.6937 9.99988C60.6937 7.23845 58.6143 4.99988 56.3224 4.99988Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoType);
export default __webpack_public_path__ + "static/media/logo_type.38892b152975271fdec5c0475838a083.svg";
export { ForwardRef as ReactComponent };